/* eslint-disable jsx-a11y/anchor-is-valid */
import React,{useRef,useEffect,useState} from 'react'
import { useAppSelector } from '../../../../../redux/hooks';
import './estiloscard.css'
import { dia, shapes } from '@joint/core';
import { Popover } from 'react-bootstrap';
import { deleteclusters,deleteclustersglobal,getclusters,getclustersglobal } from '../request/request';
import { useAuth } from '../../../auth';
import Swal from 'sweetalert2';
type ID = undefined | null | number


type Props = {
  title:any,
  name:any,
  description:any,
  ctxs:any[],
  setrecosrds:any,
  id:any,
  overallStatus: string; // Nueva prop para el estado general
  setID:any,
  suscription?:any,
  enable:any
}

const GroupsWidget: React.FC<Props> = ({title,name,description,ctxs,setrecosrds,id,overallStatus,setID,suscription,enable}) => {
  const tenant= useAppSelector(state =>state.TenantSlice.id)
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const [swalInput, setSwalInput] = useState('');
  const containerRef = useRef<HTMLDivElement>(null);
  const Type = useAppSelector(state => state.CloudSlice.Type)
  const{currentUser}= useAuth()


  function deletecluster(idcluster:any){
    Swal.fire({
        position: 'center',
        icon: 'warning',
        title: "Are you sure?",
        html:` 
        <p><strong>Once deleted, you will not be able to recover this Cluster!</strong></p>
        </br>
        <p>Note: This will disable HA cluster features, not the instance! </p> `,
        inputLabel:'Enter "confirm" to continue...',
        input: 'text',
        inputPlaceholder: 'confirm',
        inputValue: swalInput,
        showCancelButton:true,
        confirmButtonColor: '#00BCD1',
        cancelButtonColor: '#FF4089',
        confirmButtonText: 'Yes, delete it!',
        preConfirm: (value) => {
            if (!value.toLowerCase().includes('confirm')) {
              Swal.showValidationMessage('Please write the word "confirm"  to continue.');
            } else {
              setSwalInput(value);
            }
          },
      })
      .then((result) => {
        if (result.isConfirmed) {
            setSwalInput('');
            if(tenant===0 && Type!=='Global'){
                deleteclusters(Id,idcluster)
                .then(res=>{
                    if (res.data.error){
                        Swal.fire({
                        icon: 'error',
                        title: 'The Cluster cannot be removed because it is activated.'
                        });
                    }
                    else{
                    Swal.fire(
                        'Deleted!',
                        'Your Cluster has been deleted.',
                        'success'
                    );
                    }
               
                getclusters(Id).then(response=>{
                    setrecosrds(response.data)
                })
            })
            }
            else if (tenant!==0&& Type!=='Global'){
                deleteclustersglobal(Id,idcluster,tenant)
                .then(res=>{
                    if (res.data.error){
                        Swal.fire({
                        icon: 'error',
                        title: 'The Cluster cannot be removed because it is activated.'
                        });
                    }
                    else{
                    Swal.fire(
                        'Deleted!',
                        'Your Cluster has been deleted.',
                        'success'
                    );
                    }                  
                getclustersglobal(Id,tenant).then(response=>{
                    setrecosrds(response.data)
                })
            })
            
            }
            if(tenant===0 && Type==='Global'){
                deleteclusters(-1,idcluster)
                .then(res=>{
                if (res.data.error){
                    Swal.fire({
                    icon: 'error',
                    title: 'The Cluster cannot be removed because it is activated.'
                    });
                }
                else{
                Swal.fire(
                    'Deleted!',
                    'Your Cluster has been deleted.',
                    'success'
                );
                }
                getclusters(-1).then(response=>{
                    setrecosrds(response.data)
                })
            })
               

            }
            else if (tenant!==0 && Type==='Global'){
                deleteclustersglobal(-1,idcluster,tenant)
                .then(res=>{
                    if (res.data.error ==='licencia esta activada'){
                        Swal.fire({
                        icon: 'error',
                        title:'The Cluster cannot be removed because it is activated.'
                        });
                    }
                    else{
                    Swal.fire(
                        'Deleted!',
                        'Your Cluster has been deleted.',
                        'success'
                    );
                    }
                       
                getclustersglobal(-1,tenant).then(response=>{
                    setrecosrds(response.data)
                })
            })
            
            }
         
        } else {
          Swal.fire({title:"Your Cluster is safe!", icon: "success"});
        }
      }); 
}
  let names: { name: string }[] = []; 

  useEffect(() => {
    if (!containerRef.current) return;
    
    const graph = new dia.Graph();
    const paper = new dia.Paper({
      el: containerRef.current,
      model: graph,
      width: 300,
      height: 100,
      interactive:false
    });

    
    const maxLocalPrefElement = ctxs.reduce((max:any, curr:any) => max.localpref > curr.localpref ? max : curr);

    const statuspeer: boolean[] = []; // Array para almacenar los status del peer

    ctxs.map((element:any)=>{
      const image = new shapes.standard.Image();
      const xPos = element === maxLocalPrefElement ? 30 : 220; // Si es el elemento con el mayor localpref, lo colocamos a la izquierda
      image.position(xPos, 30);
      image.resize(50, 50);
      image.attr({
        image: { 'xlink:href': '/media/iconos_v2/ctx-r.png', width: 50, height: 50 },
      });
      graph.addCell(image);

      statuspeer.push(element.statuspeer);
      names.push(element.name);

    })
  
    const link = new shapes.standard.Link();
    link.source(graph.getElements()[0], { anchor: { name: 'right', args: { dx: 5 } } }); // Ajusta el punto de origen del enlace con un margen de 5 píxeles
    link.target(graph.getElements()[1], { anchor: { name: 'left', args: { dx: -5 } } }); // Ajusta el punto de destino del enlace con un margen de -5 píxeles
    //link.vertices([{x:90,y:55},{x:200,y:55}])


    statuspeer.map((status, i) => {
      if (enable===true&& status===true && statuspeer[i + 1]===true) {
        // Configurar el estilo de la línea si ambos elementos son true
        link.appendLabel({
          attrs: {             
              text: {
                  text: 'HA Up',
                  fontSize: 11,
                  'fontFamily':'Proxima Nova Font',
                  fill: '#50cd89',

              }
          }
        });
        link.attr({
          line: {
            stroke: '#50cd89',
            strokeWidth: 1,
            sourceMarker: {
              type: 'path',
              stroke: '#50cd89',
              fill: '#50cd89',
              d: 'M 10 -5 0 0 10 5 Z',
            },
            targetMarker: {
              type: 'path',
              stroke: '#50cd89',
              fill: '#50cd89',
              d: 'M 10 -5 0 0 10 5 Z',
            },
          },
        });
      } else if (enable===true&& status===true && statuspeer[i + 1]===false) {
        // Configurar el estilo de la línea si el primer elemento es true y el segundo es false
        link.appendLabel({
          attrs: {             
              text: {
                  text: 'HA Degraded',
                  fontSize: 11,
                  'fontFamily':'Proxima Nova Font',
                  fill: '#FFA500',

              }
          }
        });
        link.attr({
          line: {
            stroke: '#FFA500',
            strokeWidth: 1,
            strokeDasharray: '5 5',
            strokeDashoffset: 7.5,
            sourceMarker: {
              type: 'path',
              stroke: '#FFA500',
              fill: '#FFA500',
              d: 'M 10 -5 0 0 10 5 Z',
            },
            targetMarker: {
              type: 'path',
              stroke: '#FFA500',
              fill: '#FFA500',
              d: 'M 10 -5 0 0 10 5 Z',
            },
          },
        });
      }
      else if (enable===true&& status===false && statuspeer[i + 1]===true) {
        // Configurar el estilo de la línea si el primer elemento es true y el segundo es false
        link.appendLabel({
          attrs: {             
              text: {
                  text: 'HA Degraded',
                  fontSize: 11,
                  'fontFamily':'Proxima Nova Font',
                  fill: '#FFA500',

              }
          }
        });
        link.attr({
          line: {
            stroke: '#FFA500',
            strokeWidth: 1,
            strokeDasharray: '5 5',
            strokeDashoffset: 7.5,
            sourceMarker: {
              type: 'path',
              stroke: '#FFA500',
              fill: '#FFA500',
              d: 'M 10 -5 0 0 10 5 Z',
            },
            targetMarker: {
              type: 'path',
              stroke: '#FFA500',
              fill: '#FFA500',
              d: 'M 10 -5 0 0 10 5 Z',
            },
          },
        });
      }
      else if (enable===true&& status===false && statuspeer[i + 1]===false) {
        // Configurar el estilo de la línea si el primer elemento es true y el segundo es false
        link.appendLabel({
          attrs: {             
              text: {
                  text: 'HA Down',
                  fontSize: 11,
                  'fontFamily':'Proxima Nova Font',
                  fill: '#FF4089',

              }
          }
        });
        link.attr({
          line: {
            stroke: '#FF4089',
            strokeWidth: 1,
            strokeDasharray: '5 5',
            strokeDashoffset: 7.5,
            sourceMarker: {
              type: 'path',
              stroke: '#FF4089',
              fill: '#FF4089',
              d: 'M 10 -5 0 0 10 5 Z',
            },
            targetMarker: {
              type: 'path',
              stroke: '#FF4089',
              fill: '#FF4089',
              d: 'M 10 -5 0 0 10 5 Z',
            },
          },
        });
      }
      else if (enable===true&& status===null && statuspeer[i + 1]===null) {
        // Configurar el estilo de la línea si el primer elemento es true y el segundo es false
        link.appendLabel({
          attrs: {             
              text: {
                  text: 'No Conection',
                  fontSize: 11,
                  'fontFamily':'Proxima Nova Font',
                  fill: '#808080',

              }
          }
        });
        link.attr({
          line: {
            stroke: '#808080',
            strokeWidth: 1,
            strokeDasharray: '5 5',
            strokeDashoffset: 7.5,
            sourceMarker: {
              type: 'path',
              stroke: '#808080',
              fill: '#808080',
              d: 'M 10 -5 0 0 10 5 Z',
            },
            targetMarker: {
              type: 'path',
              stroke: '#808080',
              "stroke-width":1,
              fill: '#808080',
              d: 'M 10 -5 0 0 10 5 Z',
            },
          },
        });
      }
      else if (enable===false) {
        // Configurar el estilo de la línea si el primer elemento es true y el segundo es false
        link.appendLabel({
          attrs: {             
              text: {
                  text: 'HA Disabled',
                  fontSize: 11,
                  'fontFamily':'Proxima Nova Font',
                  fill: '#D3D3D3',

              }
          }
        });
        link.attr({
          line: {
            stroke: '#D3D3D3',
            strokeWidth: 1,
            strokeDasharray: '5 5',
            strokeDashoffset: 7.5,
            sourceMarker: {
              type: 'path',
              stroke: '#D3D3D3',
              fill: '#D3D3D3',
              d: 'M 10 -5 0 0 10 5 Z',
            },
            targetMarker: {
              type: 'path',
              stroke: '#D3D3D3',
              "stroke-width":1,
              fill: '#D3D3D3',
              d: 'M 10 -5 0 0 10 5 Z',
            },
          },
        });
      }
    });
    link.addTo(graph);

      

    
  }, [ctxs]);
  /**********************popovers************************************ */
    const popoverContent = (
    <Popover id="popover-basic" style={{ color: 'white', border: '2px solid #223357' }}>
      <Popover.Header as="h3" ></Popover.Header>
      <Popover.Body>
        {overallStatus}
      </Popover.Body>
    </Popover>
  );

  return (
    <div className="card bg-light-dark p-5" style={{ overflow: 'hidden' }}>
      <div className="d-flex justify-content-between">
        <span className="text-Marino f-parrafo fw-bold text-uppercase">{name}</span>
        <div>
            {currentUser?.ListPermiso?.includes('CTXR.Cluster.Delete')&&<span className='me-3'><i className="bi bi-trash3 fs-3" onClick={()=>deletecluster(id)}></i></span>}
           {currentUser?.ListPermiso?.includes('CTXR.Cluster.Edit')&& <span className='me-1' onClick={()=>setID(id)}><i className="bi bi-pencil-square fs-3 text-azul"></i></span>}

      </div>
      </div>

        <div className='d-flex flex-center' >
          <div ref={containerRef} style={{marginTop:-10}} ></div>
        </div>

        <div className="d-flex justify-content-between fs-8" style={{marginTop:-8, marginBottom:5}}>
          {ctxs.map((c, i) => (
            <div className="d-flex text-center flex-column  w-100 ">
              {i===0&&
                <div key={i} className="mb-1 me-5 ">
                  <span className="text-Marino f-parrafo ">{c.name}</span>
                  <br />
                  <span className="text-Marino f-parrafo">({c.description})</span>
                </div>
              }
               {i===1&&
                <div key={i} className="mb-1 ms-4">
                  <span className="text-Marino f-parrafo ">{c.name}</span>
                  <br />
                  <span className="text-Marino f-parrafo">({c.description})</span>
                </div>
              }
              
            </div>
          ))}
      </div>    

        <table className='text-marino f-parrafo mb-0 table-condensed fs-8'>
          <thead>
              <tr>
                <th className='table-cellha'>Description</th>
                <th className='table-cellha'>Priority</th>
                <th className='table-cellha'>HA status</th>
              </tr>
          </thead>
          <tbody>
          {
          ctxs.map((c,i:any)=>(
            <tr key={i}>
              <td className="table-cellha">{c.description}</td>
              <td className="table-cellha">{c.localpref}</td>
              <td className="table-cellha">{c.statuspeer === true ? <i className="ki-duotone ki-bi bi-check-circle text-success fs-7"></i> :c.statuspeer === false? <i className="ki-duotone ki-bi bi-x-circle text-pink fs-7"></i>:'---'}</td>            </tr>
          ))         
            }
          </tbody>
        </table>
        


    </div>
    )
}

export {GroupsWidget}
